export default "__VITE_ASSET__BCUCsXbY__"